<template>
  <v-card>
    <div class="transaction-confirm-card">
      <div class="modal-title">
        {{ $t("dialogs.transactionConfirm.continueInWallet") }}
      </div>
      <div class="mt-2 d-flex ga-1 align-center justify-end">
        <v-btn
          variant="text"
          size="large"
          color="rgba(255, 255, 255, 0.5)"
          class="text-uppercase"
          @click="modalData.reject && modalData.reject()"
        >
          <span v-text="$t('common.cancel')" />
        </v-btn>
        <v-btn
          color="primary"
          size="large"
          @click="modalData.confirm && modalData.confirm()"
        >
          <span v-text="$t('common.confirm')" />
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";

const { modalData } = storeToRefs(useTransactionConfirmModal());
</script>

<style lang="scss" scoped>
.transaction-confirm-card {
  position: relative;
  max-width: 460px;
  background: #1a1a1a;
  border: 1px solid #232323;
  border-radius: 10px;
  padding: 17px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 15px;
  isolation: isolate;

  > .v-card-text,
  > .v-card-actions {
    padding: 0 !important;
  }

  .modal-title {
    width: 100%;
    font-weight: 600;
    font-size: 18px;
    line-height: 13px;
    letter-spacing: 0.04em;
    color: #ffffff;
  }
}
</style>
